"use client";

import React from "react";
import { Mail, Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-8 text-center space-y-4 animate-in fade-in duration-500">
                <div className="size-12 rounded-lg bg-primary/20 flex items-center justify-center mb-2">
                    <Mail className="size-6 text-primary" />
                </div>
                <h3 className="text-xl font-default font-semibold text-foreground">You’ve joined the adventure!</h3>
                <p className="text-muted-foreground">{successMessage}</p>
                <Button onClick={resetForm} variant="outline" className="mt-4 rounded-lg border-primary text-primary hover:bg-primary/10">
                    Register another email
                </Button>
            </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <FormField control={control} name="name" render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-foreground font-medium">Name</FormLabel>
                            <FormControl>
                                <Input placeholder="Your name" {...field} className="bg-background border-border focus:border-primary rounded-md" />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />

                <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-foreground font-medium">Email</FormLabel>
                            <FormControl>
                                <Input type="email" placeholder="yourname@example.com" {...field} className="bg-background border-border focus:border-primary rounded-md" />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />
            </div>

            {submitError && <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-md">
                    <p className="text-destructive text-sm">{submitError}</p>
                </div>}

            <Button type="submit" disabled={isSubmitting} className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg font-default font-semibold transition-all shadow-md">
                {isSubmitting ? <>
                        <Loader className="mr-2 size-4 animate-spin" />
                        Sending...
                    </> : <>
                        <Mail className="mr-2 size-4" />
                        Subscribe
                    </>}
            </Button>
            
            <p className="text-xs text-muted-foreground mt-4 text-center sm:text-left">
                By subscribing, you agree to receive stories and discoveries from The Daily Explorer. You can cancel your subscription at any time.
            </p>
        </Form>;
}
export default function JoinTheJourney() {
  return <section data-section-id="259323" id="join-the-journey" className="py-16 md:py-24 bg-primary">
            <div className="container mx-auto px-4 md:px-6 max-w-3xl">
                <Card className="border-none shadow-lg bg-white rounded-lg overflow-hidden">
                    <CardHeader className="text-center pb-8">
                        <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-lg bg-secondary">
                            <Mail className="size-6 text-primary" />
                        </div>
                        <CardTitle className="text-3xl md:text-4xl font-serif font-semibold tracking-tight text-foreground">
                            Don’t Miss Any Discovery
                        </CardTitle>
                        <CardDescription className="text-lg mt-2 max-w-xl mx-auto text-muted-foreground font-default">
                            Join our community of explorers and receive the best stories directly in your inbox.
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        <FormProvider formKey="join_journey_home" formId="join_journey_home" sectionName="Newsletter Signup" defaultValues={{
            name: "",
            email: ""
          }} submitText="Subscribe" successMessage="Thank you for joining! You will soon receive our latest travel and culture chronicles.">
                            <NewsletterForm />
                        </FormProvider>
                    </CardContent>
                </Card>
            </div>
        </section>;
}